'use client'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/ui/dialog'
import { categoryType } from '@/lib/category'
import { serviceType } from '@/lib/service/server'
import { subcategoryType } from '@/lib/subcategory'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { CategoryList } from './modal/categoryList'
import { ModalSearchBox } from './modalSearch'

export function TopModal({
  service,
  text,
  icon = false,
  categories,
}: {
  service: serviceType
  categories: categoryType[]
  subcategories: subcategoryType[]
  text?: string
  icon?: boolean
}) {
  const [open, setOpen] = useState(false)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        asChild
        onClick={() => {
          setOpen(!open)
        }}
        className="cursor-pointer"
      >
        {icon ? (
          <div className="header-modal-icon w-[20px] mx-2">
            <FontAwesomeIcon icon={faSearch} fontSize={20} />
          </div>
        ) : (
          <div className="relative flex items-center">
            <p className="header-modal-text text-sm font-semibold">
              {text ? text : '商品を検索'}
            </p>
            <div className="header-modal-icon ml-2 lg:hidden">
              <FontAwesomeIcon icon={faSearch} className="text-base" />
            </div>
          </div>
        )}
      </DialogTrigger>
      <DialogContent
        className="p-3.5 border-0 bg-white w-11/12 rounded-md duration-500 overflow-y-auto max-h-[500px] "
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader className="mt-4">
          <ModalSearchBox />
        </DialogHeader>
        <CategoryList
          service={service}
          categories={categories}
          open={open}
          setOpen={setOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
